import {AppActions} from '../../types';
import {
  SET_LOC,
  //UPDATE_LOC,
  //GET_CURR_LOC,
} from '../../types/actions/CurrLoc.actions';
import {Loc} from '../../types/models/Loc';

const INIT_STATE: {
  loc: Loc  
} = {
  loc: {locid:'', locname:'', locstate:''},
};

const CurrLoc = (state = INIT_STATE, action: AppActions) => {
  switch (action.type) {
    // case UPDATE_LOC: {
    //   return {
    //     ...state,
    //     loc: action.payload,
    //   };
    // }
   
    case SET_LOC: {
      return {
        ...state,
        loc: action.payload,
      };
    }

    // case GET_CURR_LOC: {
    //   return {
    //     ...state,
    //     loc: action.payload,
    //   };
    // }
    default:
      return state;
  }
};
export default CurrLoc;
